export enum ExerciseStatus {
    Blocked = 0,
    Open = 1,
    InProgress = 2,
    Completed = 3,
}
